import { TabPanel, TabView } from 'primereact/tabview'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

/*  local imports */
// Assets
import './ChartCardPage.scss'
import { ReactComponent as Office } from 'assets/icons/card-building.svg'
import Binalar from 'assets/icons/Binalar.png'
import People from 'assets/icons/people-icon.png'
import loaderLogo from 'assets/icons/loading-statistics.png'

// Components etc.
import { ICampusServiceExists } from 'service/CampusService'
import useGetChartData from './use-get-chart-data'
import Loader from 'components/ui/Loader'
import DatePickerIcon from '../../../ui/DatePickerIcon'
import ChartContainerPage from '../../chart-containers/notification-container-page/NotificationContainerPage'
import FirmDropdownMenu from '../../chart-components/dropdown-menu/FirmDropdownMenu'
import FullnessContainer from '../../chart-containers/fullness-container-page/FullnessContainer'
import LocationDropdownMenu from '../../chart-components/dropdown-menu/LocationDropdownMenu'
import PeopleBasedChartContainer from '../../chart-containers/people-based-container/PeopleBasedChartContainer'
import ChannelChartContainerPage from '../../chart-containers/channel-container-page/ChannelContainerPage'
import OnCampusChartContainerPage from 'components/dashboard/chart-containers/on-campus-container/OnCampusContainerPage'
import { showLoading } from 'components/dashboard/DashboardHomePage'
import NotificationDist from './tabs/NotificationDist'
import PersonalDist from './tabs/PersonalDist'
import SharedOccupancyDist from './tabs/SharedOccupancyDist'
import ChannelDist from './tabs/ChannelDist'
import FirmOccupancyDist from './tabs/FirmOccupancyDist'

const minStartDate = new Date('2022-03-01')
const minEndDate = new Date('2022-03-01')

export default function ChartCardPage(props: {
  userInfo: any
  firmList: any
  campusVisible: ICampusServiceExists | undefined
}) {
  const { t } = useTranslation()
  const errorText = t('overlaypanel-texts.error-text')

  const {
    notificationResponse,
    excelData,
    channelResponse,
    companyFullness,
    maxEndDate,
    maxStartDate,
    notificationFirmUser,
    occupancy,
    checkedValue,
    setCheckedValue,
    showError,
    showLoader,
    tabIndex,
    endDate,
    setEndDate,
    setStartDate,
    startDate,
    handleTabChange,
    selectedCompany,
    selectedLocation,
    setSelectedCompany,
    setSelectedLocation,
    locationList,
    pageLoading,
    handleFirmChange,
    handleLocationChange,
  } = useGetChartData(props.firmList, props.userInfo)

  function relocateMultiSelectPanel(cnt: number) {
    let dropdown1Elm = document.getElementsByClassName('listdropdown')[0]
    var rectDropdown1Elm = dropdown1Elm.getBoundingClientRect()
    var autoCompletePanelElm = document.getElementsByClassName('p-multiselect-panel')[0]
    var autoCompleteInput = document.getElementsByClassName('p-multiselect p-component p-inputwrapper')[0]
    var rectAutoCompleteInput = autoCompleteInput.getBoundingClientRect()
    if (autoCompletePanelElm !== undefined) {
      let acpOldStyle = autoCompletePanelElm.getAttribute('style') as string
      let acpNewStyle = acpOldStyle
      acpNewStyle = acpNewStyle.concat(
        `;top: ${rectDropdown1Elm.y + rectAutoCompleteInput.height * 7.78 + window.scrollY}px!important`
      )
      autoCompletePanelElm.setAttribute('style', acpNewStyle)
    } else {
      if (cnt < 10) relocateMultiSelectPanel(++cnt)
    }
  }

  function relocateDropdownPanel(cnt: number) {
    let dropdown1Elm = document.getElementsByClassName('locationdropdown')[0]
    var rectDropdown1Elm = dropdown1Elm.getBoundingClientRect()
    var autoCompletePanelElm = document.getElementsByClassName('p-dropdown-panel')[0]
    var autoCompleteInput = document.getElementsByClassName('p-dropdown p-component p-inputwrapper')[0]
    var rectAutoCompleteInput = autoCompleteInput.getBoundingClientRect()
    if (autoCompletePanelElm !== undefined) {
      let acpOldStyle = autoCompletePanelElm.getAttribute('style') as string
      let acpNewStyle = acpOldStyle
      acpNewStyle = acpNewStyle.concat(
        `;top: ${rectDropdown1Elm.y + rectAutoCompleteInput.height * 7.48 + window.scrollY}px!important`
      )
      autoCompletePanelElm.setAttribute('style', acpNewStyle)
    } else {
      if (cnt < 10) relocateMultiSelectPanel(++cnt)
    }
  }

  const onDropdownClick = () => relocateDropdownPanel(0)

  const onMultiSelectClick = () => relocateMultiSelectPanel(0)

  const renderStatistics = () => {
    return (
      <TabWrapper>
        <TabView renderActiveOnly onTabChange={handleTabChange} activeIndex={tabIndex}>
          <TabPanel header={t('dashboard.dist-notification-details')}>
            <NotificationDist excelData={excelData?.notification}>
              <ChartContainerPage
                selectedFirms={selectedCompany}
                startDate={startDate}
                endDate={endDate}
                firmList={props.firmList}
                userInfo={props.userInfo}
                chartData={notificationResponse}
              />
            </NotificationDist>
          </TabPanel>

          <TabPanel header={t('dashboard.personal-based-dist')}>
            <PersonalDist excelData={excelData?.personal}>
              <PeopleBasedChartContainer
                detailTitle={t('dashboard.total-person-based')}
                colors={['#3ab2de', '#32896a', '#f9c06b']}
                tooltipLabel={t('dashboard.person-based-tooltip')}
                tabIndex={tabIndex}
                firmList={props.firmList}
                checkedValue={checkedValue}
                setCheckedValue={setCheckedValue}
                response={notificationFirmUser}
                detailFooter={t('dashboard.person-based-footer')}
                icon={<img src={People} width="40px" alt="people" />}
                userInfo={props.userInfo}
              />
            </PersonalDist>
          </TabPanel>

          <TabPanel header={t('dashboard.shared-office-fullness')}>
            <SharedOccupancyDist excelData={excelData?.sharedOccupancy}>
              <FullnessContainer
                tabIndex={tabIndex}
                icon={<Office fill="#198754" stroke="#198754" />}
                detailTitle={t('dashboard.total-office-notification')}
                colors={['#3D997D', '#56D9B1']}
                response={occupancy}
                userInfo={props.userInfo}
                detailFooter={t('dashboard.shared-occupancy-footer-text')}
              />
            </SharedOccupancyDist>
          </TabPanel>

          <TabPanel header={t('dashboard.channel-based-dist')}>
            <ChannelDist excelData={excelData?.channel}>
              <ChannelChartContainerPage
                firmList={props.firmList}
                colors={['#984F68', '#EE94B3', '#9FA8DB', '#8C759E']}
                labels={[
                  [
                    `${t('dashboard.mobile')} (İOS)`,
                    `${t('dashboard.mobile')} (Android)`,
                    `${t('dashboard.mobile')} (Huawei)`,
                    'Web',
                  ],
                  [
                    `${t('dashboard.mobile')} (İOS)`,
                    `${t('dashboard.mobile')} (Android)`,
                    `${t('dashboard.mobile')} (Huawei)`,
                    'Web',
                  ],
                ]}
                tabIndex={tabIndex}
                tooltipLabel={`${t('dashboard.notification-tooltip')} (${t('dashboard.channel-based')})`}
                response={channelResponse}
                userInfo={props.userInfo}
                detailFooter={t('dashboard.channel-based-footer-text')}
                icon={<img src={Binalar} width={'40px'} alt="firms" />}
                detailTitle={t('dashboard.num-of-all-notification')}
              />
            </ChannelDist>
          </TabPanel>

          <TabPanel header={t('dashboard.firm-office-fullness')}>
            <FirmOccupancyDist excelData={excelData?.firmOccupancy}>
              <FullnessContainer
                tabIndex={tabIndex}
                icon={<Office fill="#1ED2FF" stroke="#1ED2FF" />}
                detailTitle={t('dashboard.total-firm-notification')}
                colors={['#45BFE5']}
                response={companyFullness}
                userInfo={props.userInfo}
                detailFooter={t('dashboard.firm-office-footer-text')}
              />
            </FirmOccupancyDist>
          </TabPanel>

          {/* On Campus Services - Charts - Statistics */}
          {!!props.campusVisible && props.campusVisible?.isAnyExist ? (
            <TabPanel header={t('tabs.on-campus-services')}>
              <OnCampusChartContainerPage
                campusVisible={props.campusVisible}
                selectedFirms={selectedCompany}
                startDate={startDate}
                endDate={endDate}
                firmList={props.firmList}
              />
            </TabPanel>
          ) : null}
        </TabView>
      </TabWrapper>
    )
  }

  const renderErrorMessage = () => {
    //Error notification
    return (
      <div className={'h-100 error-message-container'}>
        <div style={{ textAlign: 'center' }}>
          <h3>{errorText}</h3>
        </div>
      </div>
    )
  }

  return (
    <div className="card-container">
      <div className="row">
        <div className="card-content">
          <div className="card-menu">
            <p className="mb-2">{t('dashboard.not-full')}</p>
            <div className="p-dropdown">
              <FirmDropdownMenu
                selected={selectedCompany}
                getData={handleFirmChange}
                setSelected={setSelectedCompany}
                firmList={props.firmList}
                onFocus={onMultiSelectClick}
              />
            </div>

            {(tabIndex === 2 || tabIndex === 4) && (
              <div className="p-dropdown">
                <LocationDropdownMenu
                  selectedCompany={selectedCompany}
                  selectedLocation={selectedLocation}
                  setSelectedLocation={setSelectedLocation}
                  locationList={locationList}
                  getData={handleLocationChange}
                  firmList={props.firmList}
                  userInfo={props.userInfo}
                  onFocus={() => onDropdownClick()}
                />
              </div>
            )}
          </div>

          <div className="calendar-container">
            <div>
              <DatePickerIcon
                selectOtherMonths
                showOtherMonths
                disabledDays={[]}
                idName={'dashboard-start-date'}
                defaultDate={startDate}
                minDate={minStartDate}
                maxDate={maxStartDate}
                onSelectedDateChange={(e) => {
                  setStartDate(e.value)
                }}
                label={t('input-texts.start-date')}
              />
            </div>
            <div>
              <DatePickerIcon
                selectOtherMonths
                showOtherMonths
                disabledDays={[]}
                idName="dashboard-end-date"
                defaultDate={endDate}
                minDate={minEndDate}
                maxDate={maxEndDate}
                onSelectedDateChange={(e) => setEndDate(e.value)}
                label={t('input-texts.end-date')}
              />
            </div>
          </div>
        </div>
      </div>

      {pageLoading && showLoading()}

      <div className="row">
        {!showLoader && !showError ? (
          renderStatistics()
        ) : showLoader ? (
          <div style={{ height: '500px' }}>
            <Loader src={loaderLogo} />
          </div>
        ) : showError ? (
          renderErrorMessage()
        ) : null}
      </div>
    </div>
  )
}

const TabWrapper = styled.div`
  .p-tabview-nav-container {
    margin-bottom: 0 !important;
  }
`
